export default __webpack_public_path__ + "static/Premium Table - EzyMedical (MV)-e22bda60901030f0770adcccadeaa26b.pdf";